import { ClockCircleOutlined } from '@ant-design/icons';
import { differenceInSeconds } from 'date-fns/differenceInSeconds';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTimer } from 'react-timer-hook';
import { Col, Progress, Row, Typography } from 'antd';

interface TimerProps {
  date: Date;
  timeOver: () => void;
}

const Timer = ({ date, timeOver }: TimerProps) => {
  const expiryDate = useMemo(() => new Date(date), [date]);
  const startDate = useMemo(() => new Date(), []);
  const totalDuration = useMemo(() => differenceInSeconds(expiryDate, startDate), [expiryDate, startDate]);

  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [progress, setProgress] = useState(totalDuration);

  const { minutes, seconds } = useTimer({
    expiryTimestamp: expiryDate,
    onExpire: () => {
      if (timerRef.current) clearInterval(timerRef.current);
      timeOver();
    },
  });

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setProgress(prev => Math.max(prev - 1, 0));
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [totalDuration]);

  const formatTime = (min: number, sec: number) =>
    `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;

  const percent = useMemo(() => (progress / totalDuration) * 100, [progress, totalDuration]);

  return (
    <div style={{ backgroundColor: 'white', padding: '10px' }}>
      <Row gutter={[15, 15]} justify='start'>
        <Col span={24}>
          <Typography.Text>Sua reserva expira em:</Typography.Text>
        </Col>
        <Col span={12}>
          <ClockCircleOutlined style={{ fontSize: '24px' }} />
          <Typography.Text style={{ marginLeft: '10px', fontSize: '24px' }} id='remaining-time'>
            {formatTime(minutes, seconds)}
          </Typography.Text>
        </Col>
        <Col span={24}>
          <Progress percent={Number(percent.toFixed(0))} showInfo={false} />
        </Col>
      </Row>
    </div>
  );
};

export default Timer;
